import { useEffect, useState } from 'react';
import { Table, TableProps } from 'antd';

interface TableResultProps extends TableProps<any> {
  onTableChangeHandler?: any;
  showSizeChanger: boolean;
  columns: Object[];
  dataSource: Object[];
  loading: boolean;
  defaultPageSize?: number;
}

const TableResult = ({ dataSource, columns, onTableChangeHandler, loading, showSizeChanger, defaultPageSize, ...rest }: TableResultProps) => {

  const DEFAULT_PAGE_NUM = 1;
  const DEFAULT_PAGE_SIZE = defaultPageSize ? defaultPageSize : 20;
  const [page, setPage] = useState(DEFAULT_PAGE_NUM);

  useEffect(() => {
    setPage(DEFAULT_PAGE_NUM);
  }, [dataSource]);

  return (
    <Table
      {...rest}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={{
        current: page,
        position: ['bottomCenter'],
        showSizeChanger: showSizeChanger,
        defaultPageSize: DEFAULT_PAGE_SIZE,
        total: dataSource.length,
        hideOnSinglePage: true,
        onChange: (num: number) => {
          setPage(num);
        }
      }}
      onChange={(state) => {
        if (onTableChangeHandler) onTableChangeHandler({...state});
      }}
    />
  );
}

export default TableResult;